import { ApiService } from '../../services/api_service';
import * as classNames from 'classnames';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { getSachanlagenStructure } from './functions/getEnergiedatenStructure';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import style from '../../default.less';
import assisStyle from './assistent/Assistent.less';
import myStyle from './DateneingabeSachanlagenAuswahl.less';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

interface DateneingabeSachanlagenAuswahlProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
    jahrFix?: number;
    hideJahr?: boolean;
    showHelpIcon?: boolean;
    onClose?: () => void;
}

interface DateneingabeSachanlagenAuswahlState {
    jahr: number;
    jahrMax: number;
    jahrMin: number;
    auswahlData: any[];
    showSpinner: boolean;
}

export class DateneingabeSachanlagenAuswahl extends React.Component<DateneingabeSachanlagenAuswahlProps, DateneingabeSachanlagenAuswahlState> {

    constructor(props: any) {
        super(props);
        const jahr_context = this.contextService.get('jahr_sachanlagen_auswahl');
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear() - 1;
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;
        this.state = {
            jahr: this.props.jahrFix || jahr_context || jahrMax,
            jahrMax,
            jahrMin,
            auswahlData: [],
            showSpinner: false
        };
        this.copyVorjahr = this.copyVorjahr.bind(this);
    }

    private category = 'sachanlagen';
    private saveHandle = -1;
    private domId = 'DateneingabeSachanlagenAuswahl';

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.setAuswahlData();
    }

    setAuswahlData(dataRows?: any[]): void {
        const auswahlData: any[] = (dataRows || this.props.data[IDs.ENT_ENERGIEDATEN_AUSWAHL] || [])
            .filter((a: any) => a.category === this.category).map((a: any) => { return { ...a } });
        this.setState({ auswahlData });
    }

    onChangeAuswahl(key: string, auswahl: boolean): void {
        const { auswahlData } = this.state;
        const idx = auswahlData.findIndex((r: any) =>
            r.jahr === this.state.jahr
            && (r.standort_tid_orig === this.props.standortSelected.tid || r.standort_tid === this.props.standortSelected.tid)
            && r.name === key
            && r.category === this.category
        );
        if (idx === -1) {
            auswahlData.push({
                tid: 0,
                standort_tid: this.props.standortSelected.tid,
                standort_tid_orig: this.props.standortSelected.tid,
                jahr: this.state.jahr,
                name: key,
                auswahl: auswahl ? 1 : 0,
                hinweis: '',
                category: this.category
            });
        } else {
            auswahlData[idx].auswahl = auswahl ? 1 : 0;
        }
        this.setState({ auswahlData }, this.saveDelayed);
    }

    saveDelayed(): void {
        const handle = window.setTimeout(() => {
            if (handle === this.saveHandle) {
                // console.log('Save now!');
                this.saveNow(false);
            } else {
                // console.log('Save discarded!');
            }
        }, 1000);
        this.saveHandle = handle;
        this.onDelayedSaving(true);
    }

    onDelayedSaving(isSaving: boolean): void {
        const closeBtn = document.getElementsByClassName("ui-dialog-titlebar-close");
        if (closeBtn.length > 0) {
            isSaving ?
                closeBtn[0].setAttribute('disabled', 'disabled') :
                closeBtn[0].removeAttribute('disabled');
        }
    }

    saveNow(closeAfter: boolean): boolean {
        const saveList: any[] = [];
        const auswahlData = this.state.auswahlData;
        const auswahlDataLoaded = this.props.data[IDs.ENT_ENERGIEDATEN_AUSWAHL].filter((r: any) => r.category === this.category);
        auswahlData.forEach((row: any) => {
            const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                rl.name === row.name
                && (rl.standort_tid_orig === row.standort_tid || rl.standort_tid_orig === row.standort_tid_orig)
                && rl.jahr === row.jahr
                && rl.category === row.category
            );
            if (foundLoaded) {
                if (foundLoaded.auswahl !== row.auswahl || foundLoaded.hinweis !== row.hinweis) {
                    if (row.standort_tid_orig) {
                        row.standort_tid = row.standort_tid_orig;
                    }
                    saveList.push(row);
                }
            } else {
                saveList.push(row);
            }
        });
        if (saveList.length > 0) {
            this.setState({ showSpinner: true }, () => {
                this.dataService.saveDataList(IDs.ENT_ENERGIEDATEN_AUSWAHL, saveList, () => {
                    this.triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_AUSWAHL, (data: any) => {
                        this.onDelayedSaving(false);
                        this.setState({ showSpinner: false });
                        this.setAuswahlData(data[IDs.ENT_ENERGIEDATEN_AUSWAHL]);
                    });
                    if (closeAfter) {
                        if (this.props.onClose) {
                            alert('Die Auswahl des Vorjahres wurde übernommen! Der Auswahl-Dialog wird geschlossen!');
                            this.props.onClose();
                        } else {
                            alert('Die Auswahl des Vorjahres wurde übernommen!');
                        }
                    }
                }, IDs.MOD_ETOOL);
            });
            return true;
        } else {
            return false;
        }
    }

    copyVorjahr(testOnly: boolean) {
        if (!testOnly && !window.confirm('Soll die aktuelle Auswahl durch die Auswahl des Vorjahres überschrieben werden?')) {
            return;
        }
        let auswahlData: any[] = [];
        if (testOnly) {
            auswahlData = this.state.auswahlData.map((a: any) => { return { ...a } })
        } else {
            auswahlData = this.state.auswahlData;
        }
        const auswahlLastYear = auswahlData.filter((r: any) =>
            r.jahr === (this.state.jahr - 1) && r.standort_tid_orig === this.props.standortSelected.tid
        );
        auswahlLastYear.forEach((item: any) => {
            // versuchen wir den aktuellen Eintrag zu finden
            const row = auswahlData.find((r: any) =>
                r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.name
            );
            // Fallunterscheidung
            if ((!item.auswahl && !item.hinweis) && (!row || !row.auswahl)) {
                // Alles klar... brauchen nichts machen
            } else if (item.auswahl && row && row.auswahl) {
                // Alles klar... brauchen nichts machen
            } else if ((item.auswahl || item.hinweis) && !row) {
                // Row anlegen da Auswahl noch nicht existiert
                const row_copy = { ...item };
                row_copy.tid = 0;
                row_copy.jahr = this.state.jahr;
                row_copy.standort_tid = item.standort_tid_orig;
                auswahlData.push(row_copy);
            } else if (item.auswahl && row && !row.auswahl) {
                // Einfach aktivieren
                row.auswahl = 1;
            } else if (!item.auswahl && row && (row.auswahl || item.hinweis)) {
                // Einfach deaktivieren
                row.auswahl = 0;
                if (item.hinweis) {
                    row.hinweis = item.hinweis;
                }
            }
        });
        // Jetzt noch die Entfernen, die es im Vorjahr gar nicht gibt
        auswahlData
            .filter((r: any) => r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid)
            .forEach((item: any) => {
                // versuchen wir den aktuellen Eintrag zu finden
                // Achtung, hier ist die Bezeichnung umgedreht... item ist aus auswahlData und nicht das Vorjahr
                const row = auswahlData.find((r: any) =>
                    (r.jahr === this.state.jahr - 1) && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.name
                );
                if (!row) {
                    item.auswahl = 0;
                }
            });

        if (testOnly) {
            return this.checkNow(auswahlData);
        }

        this.setState({ auswahlData }, () => {
            this.saveNow(true);
        });
    }

    checkNow(auswahlData: any[]): boolean {
        const saveList: any[] = [];
        const auswahlDataLoaded = this.props.data[IDs.ENT_ENERGIEDATEN_AUSWAHL].filter((r: any) => r.category === this.category);
        auswahlData.forEach((row: any) => {
            const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                rl.name === row.name
                && (rl.standort_tid_orig === row.standort_tid || rl.standort_tid_orig === row.standort_tid_orig)
                && rl.jahr === row.jahr
                && rl.category === row.category
            );
            if (foundLoaded) {
                if (foundLoaded.auswahl !== row.auswahl || foundLoaded.hinweis !== row.hinweis) {
                    if (row.standort_tid_orig) {
                        row.standort_tid = row.standort_tid_orig;
                    }
                    saveList.push(row);
                }
            } else {
                saveList.push(row);
            }
        });
        return saveList.length > 0;
    }

    render(): JSX.Element {
        // this.updateTids();
        const hasVorjahr = this.state.auswahlData.some((r: any) =>
            r.jahr === (this.state.jahr - 1) && r.auswahl && r.standort_tid_orig === this.props.standortSelected.tid
        );
        const structSachanlagen = getSachanlagenStructure();
        const checkVorjahr = this.copyVorjahr(true);
        return (
            <div
                id={this.domId}
                className={assisStyle.customFormInfotext}
                style={{ borderRadius: 'unset', padding: '0 20px' }}
            >
                <div
                    className={style.rowContainer}
                    style={{ alignItems: 'center', justifyContent: 'space-between', paddingTop: 5, marginBottom: 5 }}
                >
                    <div style={{ display: 'flex', alignItems: 'baseline' }}>
                        {!this.props.hideJahr && this.renderJahresauswahl()}
                        <button
                            onClick={() => this.copyVorjahr(false)}
                            disabled={!hasVorjahr || !checkVorjahr}
                            style={{
                                marginBottom: 20, padding: 5,
                                ...(!hasVorjahr || !checkVorjahr ? { cursor: 'no-drop', backgroundColor: '#bbb' } : {})
                            }}
                        >
                            Auswahl aus Vorjahr übernehmen
                        </button>
                    </div>
                </div>
                <div
                    className={style.rowContainer}
                    style={{ width: '100%', backgroundColor: 'white' }}
                >
                    <div
                        className={style.colContainer}
                        style={{ width: '100%' }}
                    >
                        {this.renderHeader(false, true)}
                        {structSachanlagen.map((item: any, idx: number) => this.renderRow(item, idx + 1000))}
                    </div>
                </div>
                {this.state.showSpinner && <WSpinner label='Speichern' />}
            </div>
        );
    }

    renderRow(item: any, idx: number): JSX.Element {
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        const row = this.state.auswahlData.find((r: any) =>
            r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.key
        );
        const auswahl: boolean = !!(item.forced || (row && row.auswahl));
        item.name = modul === 'cfm' ? (item.name || '').toString().replace('2.4.', '2.5.') : item.name;
        return (
            <div
                className={classNames(style.rowContainer, myStyle.rowContainer)}
                style={{ marginBottom: 2, height: 40 }}
                key={`div_sachanlagen_row_${idx}`}
            >
                <div className={myStyle.rowCellHelp}>
                    <WHelpIcon
                        label={item.name}
                        data={this.props.data}
                        helpKey={`sachanlagen_${item.key}`}
                        styleDivProps={{ display: 'inline-block' }}
                        // styleProps={{
                        //     width: 18, height: 20, borderRadius: 10, backgroundColor: 'transparent', verticalAlign: 'top', margin: 0
                        // }}
                        editBar
                        style='theme_small'
                        type='theme_info'
                        useTheme
                    />
                </div>
                <div
                    className={myStyle.rowCell}
                    style={{ flex: 1 }}
                >
                    {item.bold ? <b>{item.name}</b> : item.name}
                </div>
                <div
                    className={myStyle.rowCellCheckbox}
                    style={{ margin: '0 2px' }}
                >
                    <input
                        checked={auswahl}
                        onChange={(evt: any) => this.onChangeAuswahl(item.key, evt.target.checked)}
                        type='checkbox'
                        disabled={this.state.showSpinner}
                    />
                </div>
                <div
                    className={myStyle.rowCellCheckbox}
                >
                    <input
                        checked={!auswahl}
                        onChange={(evt: any) => this.onChangeAuswahl(item.key, !evt.target.checked)}
                        type='checkbox'
                        disabled={this.state.showSpinner}
                    />
                </div>
            </div>
        );
    }

    renderHeader(empty: boolean, showHelp: boolean): JSX.Element {
        return (
            <div
                className={classNames(style.rowContainer, myStyle.rowContainerHeader)}
                style={{ minHeight: 10, marginTop: 0 }}
            >
                <div className={myStyle.headerCellHelp}>
                    {this.props.showHelpIcon && showHelp &&
                        <WHelpIcon
                            label='Sachanlagen - Auswahl'
                            data={this.props.data}
                            helpKey='pageSachanlagenDaten'
                            styleDivProps={{ marginTop: 4, display: 'inline-block' }}
                            // styleProps={{
                            //     width: 18, height: 20, borderRadius: 10, backgroundColor: 'transparent', verticalAlign: 'top', margin: 0
                            // }}
                            editBar
                            style={'theme_small'}
                            type={'theme_info'}
                            useTheme
                            useWhite
                        />
                    }
                </div>
                <div
                    className={myStyle.headerCell}
                    style={{ flex: 1 }}
                >
                    {!empty && 'Sachanlagen - Kategorie'}
                </div>
                <div
                    className={myStyle.headerCellCheckbox}
                    style={{ margin: '0 2px' }}
                >
                    {!empty && 'Wird erfasst'}
                </div>
                <div
                    className={myStyle.headerCellCheckbox}
                >
                    {!empty && 'Wird nicht erfasst'}
                </div>
            </div>
        );
    }

    renderJahresauswahl(): JSX.Element {
        return (
            <div>
                <DatenauswertungJahrauswahlEinzeln
                    jahrMin={this.state.jahrMin}
                    jahrMax={this.state.jahrMax}
                    jahr={this.state.jahr}
                    disabled={this.props.jahrFix ? true : false}
                    onJahrChange={(jahr: number) => {
                        this.contextService.set('jahr_sachanlagen_auswahl', +jahr);
                        this.setState({ jahr: +jahr });
                    }}
                />
            </div>
        );
    }
}
